import React from "react";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

interface LoadingSpinnerProps {
  size?: "small" | "medium" | "large";
  center?: boolean;
  className?: string;
}

const sizeClasses = {
  small: "h-4 w-4",
  medium: "h-6 w-6",
  large: "h-8 w-8",
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "medium",
  center = true,
  className,
}) => {
  const spinner = (
    <Loader2
      className={cn(
        "animate-spin text-muted-foreground",
        sizeClasses[size],
        className,
      )}
    />
  );

  if (!center) {
    return spinner;
  }

  return <div className="flex items-center justify-center">{spinner}</div>;
};
